
import { Injectable } from '@angular/core';
import { LoggingService } from '../shared/abstraction/LoggingService';
import { Angulartics2 } from 'angulartics2';
declare var gtag: Function;
@Injectable()
export class LogService implements LoggingService {
    constructor(
        private _analytics: Angulartics2) {
    }

    Log(_action: string, _properties: any) {
        this._analytics.eventTrack.next({
            action: _action,
            properties: _properties
        });
        
    }
    // Google analytics
    public GoogleAnalytics( 
        eventName: string, 
        eventCategory: string,  
        eventLabel: string = null,  
        eventValue: number = null ){ 
            if (typeof window != 'undefined') {
                gtag('event', eventName, { 
                    'event_category': eventCategory,
                    'event_label': eventLabel,
                    'value': eventValue
                  })
                }
        }
}


